/**
 * Renders a form with the provided children elements.
 *
 * @param {Object} props - The component props.
 * @param {function} props.onSubmit - The function to call when the form is submitted.
 * @param {React.ReactNode} props.children - The child elements to render inside the form.
 * @returns {React.ReactElement} - The rendered form.
 */
const SearchForm = ({ onSubmit, children }) => (
  <form onSubmit={onSubmit}>
    {children}
  </form>
);
export default SearchForm;